import { BookOutlined, CalendarOutlined, EyeFilled, HeartOutlined, MailOutlined, PhoneOutlined, SettingOutlined, UserOutlined, CrownOutlined, UpOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Tooltip, Tag } from "antd";
import VipBadge from "../../components/VipBadge/VipBadge";
import { ColumnType } from "antd/lib/table";
import axios from "axios";
import { motion } from "framer-motion";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import coinImg from "../../assets/image/coin.png";
import CModalPointRate from "../../components/modal/CModalPointRate";
import {
    IGetUsersRequest,
    IUser,
} from "../../common/user.interface";
import CTable from "../../components/table/CTable";
import { QUERY_PARAM } from "../../constants/get-api.constant";
import { API_URL } from "../../enums/api.enums";
import { getUserRequest, getUsersStatisticRequest, checkVipUpgradeRequest, removeUserVipRequest } from "../../redux/controller";
import { useDispatchRoot, useSelectorRoot } from "../../redux/store";
import Utils from "../../utils/base-utils";
import "./user.styles.scss";

const columns: ColumnType<IUser>[] = [
    {
        title: "Số thứ tự",
        dataIndex: "index",
        width: "120px",
        render: (_, __, rowIndex) => (
            <div style={{ textAlign: "center" }}>
                {rowIndex + 1}
            </div>
        ),
    },
    {
        title: "Tên người dùng",
        dataIndex: "fullName",
        key: "fullName",
        render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <UserOutlined style={{ color: "var(--primary-color)", fontSize: "14px" }} />
                <span>{text}</span>
            </div>
        ),
    },
    {
        title: "Số điện thoại",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
        render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <PhoneOutlined style={{ color: "var(--primary-color)", fontSize: "14px" }} />
                <span>{text}</span>
            </div>
        ),
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <MailOutlined style={{ color: "var(--primary-color)", fontSize: "14px" }} />
                <span>{text}</span>
            </div>
        ),
    },
    {
        title: "Thời gian tạo",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <CalendarOutlined style={{ color: "var(--primary-color)", fontSize: "14px" }} />
                <span>{text}</span>
            </div>
        ),
    },
    {
        title: 'Số sách đã mua',
        dataIndex: 'booksBuy',
        key: 'booksBuy',
        render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <BookOutlined style={{ color: "var(--success-color)", fontSize: "14px" }} />
                <span>{text}</span>
            </div>
        ),
    },
    {
        title: 'Số sách đã yêu thích',
        dataIndex: 'booksFavorite',
        key: 'booksFavorite',
        render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <HeartOutlined style={{ color: "var(--error-color)", fontSize: "14px" }} />
                <span>{text}</span>
            </div>
        ),
    },
    {
        title: 'Số điểm',
        dataIndex: 'pointsTotal',
        key: 'pointsTotal',
        render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <img src={coinImg} alt="coin" style={{ width: 16, height: 16 }} />
                <span>{text}</span>
            </div>
        ),
    },
    {
        title: 'Trạng thái VIP',
        dataIndex: 'vipTier',
        key: 'vipTier',
        render: (vipTier, record) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <VipBadge vipTier={vipTier} showLevel={true} />
            </div>
        ),
    },
    {
        title: "Thao tác",
        dataIndex: "action",
        key: "action",
        render: (text, record) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
                {text}
            </div>
        ),
    },
];

const UserActive = () => {

    const { totalUserRecords, userStatistic } =
        useSelectorRoot((state) => state.management);
    const [currentSearchValue, setCurrentSearchValue] =
        useState<IGetUsersRequest>({
            size: QUERY_PARAM.size,
            offset: 0,
            type: "active",
        });
    const [textSearch, setTextSearch] = useState("");
    const [lstUser, setLstUser] = useState<any[]>([]);
    const [isOpenModalUserBook, setIsOpenModalUserBook] = useState(false);
    const [usersBook, setUsersBook] = useState<any[]>([]);
    const [totalUserBook, setTotalUserBook] = useState(0);
    const [isOpenModalUserPoints, setIsOpenModalUserPoints] = useState(false);
    const [userPointsDetails, setUserPointsDetails] = useState<any[]>([]);
    const [totalUserPointsHistory, setTotalUserPointsHistory] = useState(0);
    const [isOpenModalUserDailyGoal, setIsOpenModalUserDailyGoal] = useState(false);
    const [dailyGoalDetails, setDailyGoalDetails] = useState<any[]>([]);
    const [totalUserDailyGoal, setTotalUserDailyGoal] = useState(0);
    const [isOpenModalPointRate, setIsOpenModalPointRate] = useState(false);
    const dispatch = useDispatchRoot();
    const hasInitializedRef = useRef(false);
    const pointsByUserRef = useRef<Record<number, { total: number; histories: any[] }>>({});
    const dailyGoalsByUserRef = useRef<Record<number, { totalSeconds: number; items: any[] }>>({});



    useEffect(() => {
        dispatch(getUsersStatisticRequest())
    }, [totalUserRecords, dispatch])

    useEffect(() => {
        dispatch(getUserRequest(currentSearchValue));
    }, [dispatch, currentSearchValue]);

    const handleViewUserPoints = useCallback((userId: number) => {
        const detail = pointsByUserRef.current[userId]?.histories || [];
        setUserPointsDetails(detail);
        setTotalUserPointsHistory(detail.length || 0);
        setIsOpenModalUserPoints(true);
    }, []);

    const handleViewUserDailyGoal = useCallback((userId: number) => {
        const items = dailyGoalsByUserRef.current[userId]?.items || [];
        const sorted = [...items].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        setDailyGoalDetails(sorted);
        setTotalUserDailyGoal(sorted.length || 0);
        setIsOpenModalUserDailyGoal(true);
    }, []);

    const handleCheckVipUpgrade = useCallback((userId: number) => {
        dispatch(checkVipUpgradeRequest({ userId }));
    }, [dispatch]);

    const handleRemoveUserVip = useCallback((userId: number) => {
        Modal.confirm({
            title: 'Xác nhận xóa VIP',
            content: 'Bạn có chắc chắn muốn xóa trạng thái VIP của người dùng này không?',
            okText: 'Xóa',
            cancelText: 'Hủy',
            okType: 'danger',
            onOk: () => {
                dispatch(removeUserVipRequest({ userId }));
            },
        });
    }, [dispatch]);

    const fetchData = useCallback(async () => {
        if (!userStatistic || userStatistic.length === 0) return;

        let token: any = localStorage.getItem("token");
        token = token?.replace(/['"]+/g, '');

        // Fetch all points history once, then map by user
        let pointsHistory: any[] = [];
        try {
            const pointsRes = await axios.get(`${API_URL.HOST}/points/admin/history`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            pointsHistory = Array.isArray(pointsRes.data) ? pointsRes.data : (pointsRes.data?.data ?? []);
        } catch (error) {
            pointsHistory = [];
        }

        // Build map: userId -> { total, histories }
        const computedPointsByUser: Record<number, { total: number; histories: any[] }> = {};
        for (const item of pointsHistory) {
            const userId: number = item.userId;
            const type: string = (item.type || '').toString().toUpperCase();
            const delta: number = Number(item.points) || 0;

            if (!computedPointsByUser[userId]) {
                computedPointsByUser[userId] = { total: 0, histories: [] };
            }

            const signed = type === 'SPEND' ? -Math.abs(delta) : Math.abs(delta);
            computedPointsByUser[userId].total += signed;
            computedPointsByUser[userId].histories.push(item);
        }
        pointsByUserRef.current = computedPointsByUser;

        // Fetch all daily goals and map by user
        let dailyGoals: any[] = [];
        try {
            const dailyGoalRes = await axios.get(`${API_URL.HOST}/user-daily-goal/admin/all`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            dailyGoals = Array.isArray(dailyGoalRes.data) ? dailyGoalRes.data : (dailyGoalRes.data?.data ?? []);
        } catch (error) {
            dailyGoals = [];
        }

        const computedDailyGoalsByUser: Record<number, { totalSeconds: number; items: any[] }> = {};
        for (const item of dailyGoals) {
            const userId: number = item.userId;
            const seconds: number = Number(item.readingTimeSeconds) || 0;
            if (!computedDailyGoalsByUser[userId]) {
                computedDailyGoalsByUser[userId] = { totalSeconds: 0, items: [] };
            }
            computedDailyGoalsByUser[userId].totalSeconds += seconds;
            computedDailyGoalsByUser[userId].items.push(item);
        }
        dailyGoalsByUserRef.current = computedDailyGoalsByUser;

        const updatedBooks = await Promise.all(userStatistic?.map(async (book: any, index: any) => {

            const response = await fetch(`${API_URL.HOST}/user-buy-books/admin-get-books?userId=${book.id}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`,
                    }
                });
            const data = await response.json();
            const userBuyBook = data.data;

            let numberBookFavorite = 0;

            try {
                const req = await axios.get(`${API_URL.HOST}/user-favorite/user/${book.id}`)
                numberBookFavorite = req.data.data.count;
            } catch (error) { }

            // Get VIP info for user - sử dụng VipApi để có consistency
            let vipInfo = null;
            try {
                // Sử dụng VipApi.getUserVipById từ api/vip/vip.api.ts
                const vipData = await new Promise((resolve, reject) => {
                    import('../../api/vip/vip.api').then(({ default: VipApi }) => {
                        VipApi.getUserVipById(book.id).subscribe({
                            next: (data) => resolve(data),
                            error: (err) => reject(err)
                        });
                    });
                });

                console.log(`VIP data for user ${book.id}:`, vipData);
                
                // Xử lý response từ VipApi
                if (vipData && typeof vipData === 'object') {
                    // Kiểm tra nếu user có VIP
                    if ((vipData as any).userVip && (vipData as any).userVip.vipTier) {
                        vipInfo = (vipData as any).userVip.vipTier;
                        console.log(`Found VIP tier (userVip):`, vipInfo);
                    } else if ((vipData as any).vipTier) {
                        vipInfo = (vipData as any).vipTier;
                        console.log(`Found VIP tier (vipTier):`, vipInfo);
                    } else if ((vipData as any).data && (vipData as any).data.userVip && (vipData as any).data.userVip.vipTier) {
                        vipInfo = (vipData as any).data.userVip.vipTier;
                        console.log(`Found VIP tier (data.userVip):`, vipInfo);
                    }
                }
                
                if (!vipInfo) {
                    console.log(`No VIP tier found for user ${book.id}`);
                }
            } catch (error) {
                console.error(`Error fetching VIP for user ${book.id}:`, error);
                // Fallback to direct API call
                try {
                    const vipResponse = await fetch(`${API_URL.HOST}/vip/users/${book.id}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${token}`,
                        }
                    });
                    const vipData = await vipResponse.json();
                    
                    if (vipData.userVip && vipData.userVip.vipTier) {
                        vipInfo = vipData.userVip.vipTier;
                    } else if (vipData.data && vipData.data.userVip && vipData.data.userVip.vipTier) {
                        vipInfo = vipData.data.userVip.vipTier;
                    }
                } catch (fallbackError) {
                    console.error(`Fallback VIP fetch failed for user ${book.id}:`, fallbackError);
                }
            }

            const pointsInfo = pointsByUserRef.current[book.id] ?? { total: 0, histories: [] };

            return {
                index: index + 1,
                id: book.id,
                fullName: book.username,
                phoneNumber: book.phoneNumber,
                email: book.email,
                createdAt: moment(book.createdAt).format("DD/MM/YYYY HH:mm:ss"),
                booksBuy: userBuyBook.count,
                booksFavorite: numberBookFavorite,
                pointsTotal: pointsInfo.total,
                vipTier: vipInfo,
                isVip: !!vipInfo,
                action: (
                    <Space>
                        <Tooltip title="Xem sách đã mua">
                            <EyeFilled
                                onClick={() => handeViewBookBuy(userBuyBook)}
                                style={{ color: "var(--primary-color)", cursor: "pointer" }}
                            />
                        </Tooltip>
                        <Tooltip title="Xem chi tiết điểm">
                            <EyeFilled
                                onClick={() => handleViewUserPoints(book.id)}
                                style={{ color: "#faad14", cursor: "pointer" }}
                            />
                        </Tooltip>
                        <Tooltip title="Xem daily goal">
                            <EyeFilled
                                onClick={() => handleViewUserDailyGoal(book.id)}
                                style={{ color: "#722ed1", cursor: "pointer" }}
                            />
                        </Tooltip>
                        <Tooltip title="Kiểm tra nâng cấp VIP">
                            <UpOutlined
                                onClick={() => handleCheckVipUpgrade(book.id)}
                                style={{ color: "#52c41a", cursor: "pointer" }}
                            />
                        </Tooltip>
                        {vipInfo && (
                            <Tooltip title="Xóa VIP">
                                <DeleteOutlined
                                    onClick={() => handleRemoveUserVip(book.id)}
                                    style={{ color: "#ff4d4f", cursor: "pointer" }}
                                />
                            </Tooltip>
                        )}
                    </Space>
                ),

            }
        }));

        setLstUser(updatedBooks);
    }, [userStatistic]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        console.log(userStatistic);
        if (userStatistic && userStatistic.length > 0 && !hasInitializedRef.current) {
            hasInitializedRef.current = true;
            fetchData();
        }
    }, [userStatistic]); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangePagination = (event: any) => {
        currentSearchValue.offset = (event - 1) * QUERY_PARAM.size;
        setCurrentSearchValue(currentSearchValue);
        dispatch(getUserRequest(currentSearchValue));
    };

    const onChangeInput = (event: any) => {
        setTextSearch(event.target.value);
    };

    const onSearch = () => {
        const body: IGetUsersRequest = {
            size: QUERY_PARAM.size,
            offset: 0,
            search: textSearch,
            type: "active",
        };
        const finalBody = Utils.getRidOfUnusedProperties(body);
        setCurrentSearchValue(finalBody);
        dispatch(getUserRequest(finalBody));
    };



    const handeViewBookBuy = (data: any) => {
        console.log("data", data);
        setUsersBook(data.items);
        setIsOpenModalUserBook(true);
        setTotalUserBook(data.count);
    }



    return (
        <motion.div
            className="sketch-main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className="table-area">
                <div style={{ marginBottom: "20px", textAlign: "right" }}>
                    <Button
                        type="primary"
                        icon={<SettingOutlined />}
                        onClick={() => setIsOpenModalPointRate(true)}
                        style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                    >
                        Cài đặt tỷ lệ quy đổi điểm
                    </Button>
                </div>
                <CTable
                    tableMainTitle="Danh sách người dùng"
                    allowTextSearch={false}
                    onChangeInput={onChangeInput}
                    onSearch={onSearch}
                    titleOfColumnList={columns}
                    data={lstUser}
                    textSearch="Tên người dùng, email"
                    totalRecord={totalUserRecords}
                    onChangePagination={onChangePagination}
                    allowAddObject={true}
                    pageSize={10}
                />
            </div>
            <Modal
                title={
                    <Space>
                        <BookOutlined />
                        <span>Sách đã mua</span>
                    </Space>
                }
                visible={isOpenModalUserBook}
                onCancel={() => setIsOpenModalUserBook(false)}
                footer={null}
                width={1000}
                className="modal-user-book"
            >
                <div className="table-area">
                    <CTable
                        tableMainTitle=""
                        allowTextSearch={false}
                        onChangeInput={onChangeInput}
                        onSearch={onSearch}
                        titleOfColumnList={
                            [
                                {
                                    title: 'Tên sách',
                                    dataIndex: 'name',
                                    key: 'name',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {record.book.name}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Tác giả',
                                    dataIndex: 'author',
                                    key: 'author',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {record.book.authorsBooks && record.book.authorsBooks.map((author: any) => author.author.middleName ? author.author.firstName + " " + author.author.middleName + " " + author.author.lastName : author.author.firstName + " " + author.author.lastName).join(", ")}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Thời gian tạo',
                                    dataIndex: 'createdAt',
                                    key: 'createdAt',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {moment(record.book.updatedAt).format("DD/MM/YYYY HH:mm:ss")}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Giá',
                                    dataIndex: 'price',
                                    key: 'price',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {Utils.formatMoney(record.book.pricePaper) + "VNĐ"}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Ảnh bìa',
                                    dataIndex: 'cover',
                                    key: 'cover',
                                    render: (text: any, record: any) => {
                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <img
                                                    style={{ width: "90px", height: "110px" }}
                                                    src={`${API_URL.HOST}/books/preview-images?id=${record.book.id}`}
                                                    alt=""
                                                />
                                            </div>
                                        );
                                    }
                                }
                            ]
                        }
                        data={usersBook}
                        totalRecord={totalUserBook}
                        onChangePagination={onChangePagination}
                        allowAddObject={true}
                        textSearch="Tìm kiếm sách theo tên"
                        pageSize={10}
                        size={400}
                    />
                </div>
            </Modal>

            <Modal
                title={
                    <Space>
                        <img src={coinImg} alt="coin" style={{ width: 16, height: 16 }} />
                        <span>Chi tiết điểm</span>
                    </Space>
                }
                visible={isOpenModalUserPoints}
                onCancel={() => setIsOpenModalUserPoints(false)}
                footer={null}
                width={900}
                className="modal-user-points"
            >
                <div className="table-area">
                    <CTable
                        tableMainTitle=""
                        allowTextSearch={false}
                        onChangeInput={onChangeInput}
                        onSearch={onSearch}
                        titleOfColumnList={
                            [
                                {
                                    title: 'Mô tả',
                                    dataIndex: 'description',
                                    key: 'description',
                                    render: (text: any) => (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {text}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Loại',
                                    dataIndex: 'type',
                                    key: 'type',
                                    render: (text: any) => (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {text}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Điểm',
                                    dataIndex: 'points',
                                    key: 'points',
                                    render: (text: any, record: any) => {
                                        const type = (record.type || '').toString().toUpperCase();
                                        const value = Number(record.points) || 0;
                                        const signed = type === 'SPEND' ? -Math.abs(value) : Math.abs(value);
                                        const color = signed >= 0 ? 'var(--success-color)' : 'var(--error-color)';
                                        const sign = signed >= 0 ? '+' : '-';
                                        return (
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", color }}>
                                                {`${sign}${Math.abs(signed)}`}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Thời gian',
                                    dataIndex: 'createdAt',
                                    key: 'createdAt',
                                    render: (text: any) => (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {moment(text).format("DD/MM/YYYY HH:mm:ss")}
                                        </div>
                                    )
                                }
                            ]
                        }
                        data={userPointsDetails}
                        totalRecord={totalUserPointsHistory}
                        onChangePagination={onChangePagination}
                        allowAddObject={true}
                        textSearch="Tìm kiếm mô tả"
                        pageSize={10}
                        size={400}
                    />
                </div>
            </Modal>

            <Modal
                title={
                    <Space>
                        <CalendarOutlined />
                        <span>Daily goal</span>
                    </Space>
                }
                visible={isOpenModalUserDailyGoal}
                onCancel={() => setIsOpenModalUserDailyGoal(false)}
                footer={null}
                width={900}
                className="modal-user-daily-goal"
            >
                <div className="table-area">
                    <CTable
                        tableMainTitle=""
                        allowTextSearch={false}
                        onChangeInput={onChangeInput}
                        onSearch={onSearch}
                        titleOfColumnList={
                            [
                                {
                                    title: 'Ngày',
                                    dataIndex: 'date',
                                    key: 'date',
                                    render: (text: any) => (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {moment(text).format("DD/MM/YYYY")}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Thời gian đọc',
                                    dataIndex: 'readingTimeSeconds',
                                    key: 'readingTimeSeconds',
                                    render: (text: any) => {
                                        const total = Number(text) || 0;
                                        const minutes = Math.floor(total / 60);
                                        const seconds = total % 60;
                                        return (
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                {minutes > 0 ? `${minutes} phút ${seconds} giây` : `${seconds} giây`}
                                            </div>
                                        );
                                    }
                                },
                                {
                                    title: 'Cập nhật',
                                    dataIndex: 'updatedAt',
                                    key: 'updatedAt',
                                    render: (text: any) => (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {moment(text).format("DD/MM/YYYY HH:mm:ss")}
                                        </div>
                                    )
                                }
                            ]
                        }
                        data={dailyGoalDetails}
                        totalRecord={totalUserDailyGoal}
                        onChangePagination={onChangePagination}
                        allowAddObject={true}
                        textSearch="Tìm kiếm theo ngày"
                        pageSize={10}
                        size={400}
                    />
                </div>
            </Modal>

            <CModalPointRate
                visible={isOpenModalPointRate}
                onCancel={() => setIsOpenModalPointRate(false)}
                onSuccess={() => {
                    // Optional: Refresh data or show success message
                }}
            />
        </motion.div>
    );
};

export default UserActive;
